<template>
  <section class="relative w-full main-page">
    <!-- Desktop layout -->
    <div
      class="flex items-between client-status-block rounded-lg scroll-styling top relative"
    >

      <!-- Burger button (mobile only) -->
      <button
        @click="isMenuOpen = !isMenuOpen"
        class="md:hidden absolute top-4 left-0 z-40 bg-indigo-600 text-white rounded-r-lg p-1 text-sm"
      >
        ☰
      </button>

      <!-- Modal menu (mobile only) -->
      <div
        v-if="isMenuOpen"
        class="md:hidden absolute inset-0 bg-black bg-opacity-50 z-30 rounded-lg"
        @click="isMenuOpen = false"
      ></div>
      <div
        v-if="isMenuOpen"
        class="md:hidden absolute top-0 left-0 h-full w-64 bg-white z-40 overflow-y-auto rounded-lg"
      >
      <button
        @click="isMenuOpen = false"
        class="absolute top-3 right-3 text-gray-500 text-lg font-bold w-6 h-6 flex items-center justify-center hover:bg-gray-200 rounded"
      >
        ✕
      </button>
      <nav class="flex-1 space-y-1 p-3 pt-10">
        <router-link
          v-slot="{ href, navigate, isActive }"
          :to="{
            name: 'ClientProfile',
          }"
        >
          <div
            class="flex items-center px-3 py-2 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
            @click="navigate; isMenuOpen = false"
            :class="[
              isActive ? 'bg-indigo-600 text-white-imp' : '',
            ]"
            :href="href"
          >
            <svg
              class="flex-shrink-0 w-5 h-5 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
            </svg>
            Профиль
          </div>
        </router-link>
        <router-link
          v-if="[0, 1, 2, 3, 4].includes(user.role.key)"
          v-slot="{ href, navigate, isActive }"
          :to="{
            name: 'ExperProfieletList',
          }"
        >
          <div
            class="flex items-center px-3 py-2 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
            @click="navigate; isMenuOpen = false"
            :class="[
              isActive ? 'bg-indigo-600 text-white-imp' : '',
            ]"
            :href="href"
          >
            <svg
              class="flex-shrink-0 w-5 h-5 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
            </svg>
            Эксперты
          </div>
        </router-link>
        <template v-if="user.role.key !== 4">
          <router-link
            v-if="user.role.key === 1"
            v-slot="{ href, navigate, isActive }"
            :to="{
              name: 'ClientCourseSatus',
            }"
          >
            <div
              class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
              @click="navigate; isMenuOpen = false"
              :class="[
                isActive ? 'bg-indigo-600 text-white-imp' : '',
              ]"
              :href="href"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                />
              </svg>
              Заявки
            </div>
          </router-link>
          <router-link
            v-if="[0, 1, 2, 3, 4].includes(user.role.key)"
            v-slot="{ href, navigate, isActive }"
            :to="{
              name: 'ClientCourses',
            }"
          >
            <div
              class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
              @click="navigate; isMenuOpen = false"
              :class="[
                isActive ? 'bg-indigo-600 text-white-imp' : '',
              ]"
              :href="href"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                />
              </svg>
              Курсы
            </div>
          </router-link>
          <router-link
            v-slot="{ href, navigate, isActive }"
            :to="{
              name: 'ClienntTsor',
            }"
          >
            <div
              class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
              @click="navigate; isMenuOpen = false"
              :class="[
                isActive ? 'bg-indigo-600 text-white-imp' : '',
              ]"
              :href="href"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                />
              </svg>
              Учебные материалы
            </div>
          </router-link>
        </template>
        <router-link
          v-slot="{ href, navigate, isActive }"
          :to="{
            name: 'TrainingClientIndex',
          }"
        >
          <div
            class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
            @click="navigate; isMenuOpen = false"
            :class="[
              isActive ? 'bg-indigo-600 text-white-imp' : '',
            ]"
            :href="href"
          >
            <svg
              class="flex-shrink-0 w-5 h-5 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
            </svg>
            Календарь тренингов
          </div>
        </router-link>
        <router-link
          v-if="[0, 2, 4].includes(user.role.key)"
          v-slot="{ href, navigate, isActive }"
          :to="{
            name: 'ResponsesList',
          }"
        >
          <div
            class="flex items-center px-3 py-2 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
            @click="navigate; isMenuOpen = false"
            :class="[
              isActive ? 'bg-indigo-600 text-white-imp' : '',
            ]"
            :href="href"
          >
            <svg
              class="flex-shrink-0 w-5 h-5 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
            </svg>
            Отклики
          </div>
        </router-link>
        <router-link
          v-if="user.role.key === 3"
          v-slot="{ href, navigate, isActive }"
          :to="{
            name: 'ModeratorResponsesList',
          }"
        >
          <div
            class="flex items-center px-3 py-2 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
            @click="navigate; isMenuOpen = false"
            :class="[
              isActive ? 'bg-indigo-600 text-white-imp' : '',
            ]"
            :href="href"
          >
            <svg
              class="flex-shrink-0 w-5 h-5 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
            </svg>
            Отклики
          </div>
        </router-link>
      </nav>
    </div>

      <!-- Desktop sidebar (always visible on desktop) -->
      <div class="status-nav inl-20 hidden md:block">
        <nav class="flex-1 space-y-2 pr-2">
          <router-link
            v-slot="{ href, navigate, isActive }"
            :to="{
              name: 'ClientProfile',
            }"
            >
            <div
              class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
              @click="navigate"
              :class="[
                isActive  ? 'bg-indigo-600 text-white-imp': '',
              ]"
              :href="href"
            >
              <svg
              class="flex-shrink-0 w-5 h-5 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
              </svg>
              Профиль
            </div>
          </router-link>
          <router-link
            v-if="[0, 1, 2, 3, 4].includes(user.role.key)"
            v-slot="{ href, navigate, isActive }"
            :to="{
              name: 'ExperProfieletList',
            }"
            >
            <div
              class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
              @click="navigate"
              :class="[
                isActive  ? 'bg-indigo-600 text-white-imp': '',
              ]"
              :href="href"
            >
              <svg
              class="flex-shrink-0 w-5 h-5 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
              </svg>
              Эксперты
            </div>
          </router-link>
          <template v-if="user.role.key !== 4">
            <router-link
              v-if="user.role.key === 1"
              v-slot="{ href, navigate, isActive }"
              :to="{
                name: 'ClientCourseSatus',
              }"
              >
              <div
                class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
                @click="navigate"
                :class="[
                  isActive  ? 'bg-indigo-600 text-white-imp': '',
                ]"
                :href="href"
              >
                <svg
                class="flex-shrink-0 w-5 h-5 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                />
                </svg>
                Заявки
              </div>
            </router-link>
            <router-link
              v-if="[0, 1, 2, 3, 4].includes(user.role.key)"
              v-slot="{ href, navigate, isActive }"
              :to="{
                name: 'ClientCourses',
              }"
            >
              <div
                class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
                @click="navigate"
                :class="[
                  isActive  ? 'bg-indigo-600 text-white-imp': '',
                ]"
                :href="href"
              >
                <svg
                  class="flex-shrink-0 w-5 h-5 mr-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                  />
                </svg>
                Курсы
              </div>
            </router-link>
            <router-link
              v-slot="{ href, navigate, isActive }"
              :to="{
                name: 'ClienntTsor',
              }"
            >
              <div
                class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
                @click="navigate"
                :class="[
                  isActive  ? 'bg-indigo-600 text-white-imp': '',
                ]"
                :href="href"
              >
                <svg
                  class="flex-shrink-0 w-5 h-5 mr-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                  />
                </svg>
                Учебные материалы
              </div>
            </router-link>
          </template>
          <router-link
            v-slot="{ href, navigate, isActive }"
            :to="{
              name: 'TrainingClientIndex',
            }"
          >
            <div
              class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
              @click="navigate"
              :class="[
                isActive  ? 'bg-indigo-600 text-white-imp': '',
              ]"
              :href="href"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                />
              </svg>
              Календарь тренингов
            </div>
          </router-link>

          <!-- Responses link for all authenticated users -->
          <router-link
            v-if="[0, 2, 4].includes(user.role.key)"
            v-slot="{ href, navigate, isActive }"
            :to="{
              name: 'ResponsesList',
            }"
            >
            <div
              class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
              @click="navigate"
              :class="[
                isActive  ? 'bg-indigo-600 text-white-imp': '',
              ]"
              :href="href"
            >
              <svg
              class="flex-shrink-0 w-5 h-5 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
              </svg>
              Отклики
            </div>
          </router-link>

          <!-- Moderator responses link (all responses, read-only) -->
          <router-link
            v-if="user.role.key === 3"
            v-slot="{ href, navigate, isActive }"
            :to="{
              name: 'ModeratorResponsesList',
            }"
            >
            <div
              class="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 text-gray-900 hover:text-white rounded-lg hover:bg-indigo-600 group"
              @click="navigate"
              :class="[
                isActive  ? 'bg-indigo-600 text-white-imp': '',
              ]"
              :href="href"
            >
              <svg
              class="flex-shrink-0 w-5 h-5 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
              </svg>
              Отклики
            </div>
          </router-link>

        </nav>
      </div>
      <router-view class="inl-78 inl-m-100 pt-2"></router-view>

    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      isMenuOpen: false,
    }
  },
  computed: mapState(['user']),
}
</script>

<style>
  .text-white-imp {
    color: #fff!important;
  }
</style>
